<template>
  <MUIDialog
    :displayType="displayType"
    :acceptItem="acceptItem"
    :acceptOnEnter="false"
    :dismissItem="dismissItem"
    :scrollable="true"
    :title="title"
    ref="dialog">
    <RecipeForm :recipeKey="recipeKey" ref="form"></RecipeForm>
  </MUIDialog>
</template>

<script>
import { APP } from '../config'

import {
  MUIDialog,
  RecipeForm } from '../components'

export default {
  components: {
    MUIDialog,
    RecipeForm
  },
  props: [
    'recipeKey'
  ],
  data () {
    return {
      acceptItem: {
        name: 'Save',
        fn: () => this.acceptHandler()
      },
      dismissItem: {
        name: 'Cancel'
      },
      displayType: APP,
      title: 'Edit Recipe'
    }
  },
  methods: {
    acceptHandler () {
      const form = this.$refs.form
      form.validate()
      if (form.errors.length > 0) return

      this.$store.dispatch('updateRecipe', {
        key: this.recipeKey,
        updatedRecipe: form.model,
        uid: this.$store.state.User.uid
      })
      this.$track('recipe.update', {
        context: 'recipe',
        ability: 'update',
        recipeId: this.recipeKey,
        sourceType: 'manual'
      })
      this.$refs.dialog.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/RecipeEditDialog.vue